import { toQueryParams } from "helpers/url";
import { BaseService } from "services/_baseService";
import appAxios from "services/axios";

class ReturnsAdminService extends BaseService<any> {
  constructor() {
    super(`returns`);
  }
  getAllByOrgID = async (orgID: string, queryParams: object = {}): Promise<any[]> => {
    return appAxios.get(`${this.pathWithOrg()}?` + toQueryParams(queryParams));
  };
  get = async (id: number): Promise<any> => {
    return appAxios.get(`${this.pathWithOrg()}/${id}`);
  };
  refund = async (returnID: number): Promise<any> => {
    return appAxios.get(`${this.pathWithOrg()}/${returnID}/refunds`);
  };
}

export default new ReturnsAdminService();
